import { render, staticRenderFns } from "./article-price-table.vue?vue&type=template&id=7d5ea31d&scoped=true&"
import script from "./article-price-table.ts?vue&type=script&lang=ts&"
export * from "./article-price-table.ts?vue&type=script&lang=ts&"
import style0 from "./article-price-table.scss?vue&type=style&index=0&id=7d5ea31d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5ea31d",
  null
  
)

export default component.exports